// extracted by mini-css-extract-plugin
export default {"iconCard":"icon-card-module--iconCard--xc_6W","icon":"icon-card-module--icon--3BAJD","title":"icon-card-module--title--fQ-4o","body":"icon-card-module--body--2LWKM"};